// frescuraTexto.js — P3-10 punto 2 (frontend). Convierte { fuente, haceSeg } (lo
// que rotula el backend en GET /full) en el texto de frescura de la ficha.
// Frontend-only → export ES (NO module.exports): el build caza el mismatch
// CJS/ESM que jest no ve. Puro.

// Segundos → «hace unos segundos» / «hace N min» / «hace N h» (escala a horas
// desde 90 min, como haceTiempoW de Analítica).
export function haceTextoFrescura(seg) {
  if (seg == null || !Number.isFinite(seg)) return '';
  if (seg < 60) return 'hace unos segundos';
  const min = Math.round(seg / 60);
  if (min < 90) return `hace ${min} min`;
  return `hace ${Math.round(min / 60)} h`;
}

// frescura: { fuente:'woo'|'espejo'|'espejo-stale', haceSeg }
// → { texto, alerta } | null. alerta=true SOLO cuando la tienda no respondió y se
// está mostrando el espejo viejo (espejo-stale): ahí el texto avisa el riesgo.
export function textoFrescura(frescura) {
  if (!frescura) return null;
  const { fuente, haceSeg } = frescura;
  if (fuente === 'espejo-stale') {
    return { texto: `Datos de ${haceTextoFrescura(haceSeg)} — la tienda no respondió`, alerta: true };
  }
  if (fuente === 'woo') {
    return { texto: 'Sincronizado con la tienda recién', alerta: false };
  }
  return { texto: `Sincronizado ${haceTextoFrescura(haceSeg)}`, alerta: false };
}
